"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var CompressedModelDetails_1 = require("./CompressedModelDetails");
var lodash_1 = require("lodash");
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var DataType_1 = require("../common/base/DataType");
var jsonpack_1 = tslib_1.__importDefault(require("jsonpack"));
var SceCompressedProperties = /** @class */ (function () {
    function SceCompressedProperties() {
        this.models = [];
    }
    SceCompressedProperties.fromJson = function (json) {
        var properties = new SceCompressedProperties();
        properties.models = lodash_1.map(Object.keys(json), function (key) {
            return CompressedModelDetails_1.CompressedModelDetails.fromJson(key, json[key]);
        });
        return properties;
    };
    SceCompressedProperties.prototype.addModel = function (modelId, typeId, version, name, json) {
        var compressedModelDetails = new CompressedModelDetails_1.CompressedModelDetails();
        compressedModelDetails.key = modelId.split('.').join('_');
        compressedModelDetails.model = new DataItem_1.DataItem(Field_1.FIELD.MODEL, DataType_1.DataType.string);
        compressedModelDetails.model.value = modelId;
        compressedModelDetails.name = new DataItem_1.DataItem(Field_1.FIELD.NAME, DataType_1.DataType.string);
        compressedModelDetails.name.value = name;
        compressedModelDetails.typeId = new DataItem_1.DataItem(Field_1.FIELD.TYPEID, DataType_1.DataType.string);
        compressedModelDetails.typeId.value = typeId;
        compressedModelDetails.version = new DataItem_1.DataItem(Field_1.FIELD.VERSION, DataType_1.DataType.string);
        compressedModelDetails.version.value = version;
        compressedModelDetails.content = new DataItem_1.DataItem(Field_1.FIELD.MODEL, DataType_1.DataType.string);
        console.log("inside addModel json conetnet", json);
        compressedModelDetails.content.value = JSON.stringify(jsonpack_1.default.pack(json));
        this.models.push(compressedModelDetails);
    };
    SceCompressedProperties.prototype.updateContentForModel = function (modelId, updatedJson) {
        var key = modelId.split('.').join('_');
        var model = lodash_1.find(this.models, function (model) {
            return model.key === key;
        });
        if (!model) {
            throw new Error("ModelId " + modelId + " not found");
        }
        model.content.value = JSON.stringify(jsonpack_1.default.pack(updatedJson));
    };
    SceCompressedProperties.prototype.removeModel = function (modelId) {
        var key = modelId.split('.').join('_');
        var modelIndex = lodash_1.findIndex(this.models, function (model) {
            return model.key === key;
        });
        if (modelIndex === -1) {
            throw new Error("Model key " + key + " not found!");
        }
        this.models.splice(modelIndex, 1);
    };
    SceCompressedProperties.prototype.getUncompressedModel = function (modelId) {
        var key = modelId.split('.').join('_');
        var model = lodash_1.find(this.models, function (model) {
            return model.key === key;
        });
        if (model) {
            return jsonpack_1.default.unpack(JSON.parse(model.content.value));
        }
        return {};
    };
    SceCompressedProperties.prototype.toJson = function () {
        var json = Object.create(null);
        var jsonModel = Object.create(null);
        lodash_1.map(this.models, function (model) {
            jsonModel = Object.assign(jsonModel, model.toJson());
        });
        json[Field_1.FIELD.MODELS] = jsonModel;
        return json;
    };
    return SceCompressedProperties;
}());
exports.SceCompressedProperties = SceCompressedProperties;
//# sourceMappingURL=SceCompressedProperties.js.map